export default class Result<T> {
    public value: T;
    public status: string;
    public hasError: boolean;
    constructor(value: T, Status: string = "") {
        var showError = true;
        this.hasError = !(Status == '200');
        if (Status == '200') {
            this.value = value;
            this.status = Status;
        }
        else {
            this.value = null;
            this.status = Status;
        }        
    }
}

